import IncomeLevel from './IncomeLevel'

export default IncomeLevel